/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React, { useState } from "react";
import { IconContainer, SwitchContainer } from "./SwitchSelector.styled";
import { BlueLeftArrow } from "../../../Components/Icons/BlueLeftArrow";
import { BlueRightArrow } from "../../../Components/Icons/BlueRightArrow";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Direction = {
  LEFT: "left",
  RIGHT: "right"
};

const SwitchSelector = ({ options, selectedOption, emitSelectionChange }) => {
  const { t } = useTranslation();
  const [direction, setDirection] = useState(Direction.RIGHT);
  const currentOptionIndex = options.findIndex((option) => option === selectedOption);

  const changeOption = (newIndex, newDirection) => {
    let nextIndex = newIndex;

    if (newIndex < 0) {
      nextIndex = options.length - 1;
    } else if (newIndex >= options.length) {
      nextIndex = 0;
    }

    const newOption = options[nextIndex];
    emitSelectionChange(newOption);
    setDirection(newDirection);
  };

  return (
    <SwitchContainer>
      <IconContainer onClick={() => changeOption(currentOptionIndex - 1, Direction.LEFT)}>
        <BlueLeftArrow />
      </IconContainer>

      <motion.div
        key={selectedOption.label}
        initial={{ opacity: 0, x: direction === Direction.LEFT ? 20 : -20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: direction === Direction.LEFT ? -20 : 20 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        aria-live="polite"
      >
        <span style={{ userSelect: "none" }}>{t(selectedOption.label)}</span>
      </motion.div>

      <IconContainer onClick={() => changeOption(currentOptionIndex + 1, Direction.RIGHT)}>
        <BlueRightArrow />
      </IconContainer>
    </SwitchContainer>
  );
};

export default SwitchSelector;
